import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DeviceTable from "components/deviceTable";
import CalibrationHistoryTable from "components/calibrationHistoryTable";
import { setCalibrationHistory } from "store/slices/firebaseSlice";
import { collection, getDocs } from "firebase/firestore";
import { db } from "services/firebase";

function CalibrationHistory() {
  const dispatch = useDispatch();
  const { clientId, calibrationHistoryData, deviceIds } = useSelector((state) => state.firebase);
  const [selectedDevice, setSelectedDevice] = useState(null);

  useEffect(() => {
    if (!clientId || !selectedDevice) return;

    const getCalibrationHistory = async () => {
      const calibrationHistory = await getDocs(
        collection(db, "Results", clientId, "devices", selectedDevice, "calibrationHistory")
      );
      let data = [];
      for (const doc of calibrationHistory.docs) {
        const result = doc.data();
        if (result.date && result.date.toDate) {
          result.date = result.date.toDate();
        }
        data = [...data, { ...result, id: doc.id }];
      }
      dispatch(setCalibrationHistory(data));
    };
    getCalibrationHistory();
  }, [selectedDevice, clientId, dispatch]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={2.4}>
            <DeviceTable
              clientId={clientId}
              deviceIds={deviceIds}
              selectedDevice={selectedDevice}
              onDeviceSelect={setSelectedDevice}
            />
          </Grid>

          {selectedDevice && (
            <Grid item xs={12} md={9}>
              <CalibrationHistoryTable
                selectedDevice={selectedDevice}
                calibrationHistoryData={calibrationHistoryData}
              />
            </Grid>
          )}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CalibrationHistory;
